const config = {
  basePath: "/app",
  apiPath: "/app/api",
  origDomain: "//cashplane.net",
  env: process.env.NODE_ENV
}
if (config.env == "development") {
  config.origDomain = "//cashplane"
}

export default config;